/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import moment from 'moment';
import CustomDatePicker, { DatePickerProps, DateValue } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFDatePickerProps<
  FormFields extends FieldValues,
> extends DatePickerProps, CommonReactHookFormProps<FormFields> {
  onDateChange?: (date: DateValue) => void;
}

function RHFDatePicker<FormFields extends FieldValues>(
  props: RHFDatePickerProps<FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    onChange,
    onDateChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange: onFieldChange } = field;

  const handleChange = (event: DateValue) => {
    if (onDateChange) {
      onDateChange(event);
    }
    onFieldChange(moment(event).format());
  };

  return (
    <CustomDatePicker
      label={label}
      value={field.value}
      error={error}
      onChange={handleChange}
      {...rest}
    />
  );
}

RHFDatePicker.defaultProps = {
  onDateChange: () => {},
};

export default RHFDatePicker;
